module.exports = __webpack_public_path__ + "img/weimeng.deb9d003.png";